import { render, staticRenderFns } from "./anumbergroupscomponent.vue?vue&type=template&id=01622c67&"
import script from "./anumbergroupscomponent.vue?vue&type=script&lang=ts&"
export * from "./anumbergroupscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports